import cn from 'classnames';
import React from 'react';

export const DishModalContent = React.forwardRef<HTMLDivElement, React.PropsWithChildren<{ className?: string }>>(
  ({ className, children }, ref) => (
    <div ref={ref} className={cn('px-4', className)}>
      {children}
    </div>
  )
);

DishModalContent.displayName = 'DishModalContent';
